import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'contextual-summary.gadgets.activity-feed.title',
		defaultMessage: 'Recent activity',
		description:
			'Title for the Activity Feed which displays a feed of recent issue-centric events/activities on a Jira site, such as updating fields like assignee/status/priority.',
	},
	description: {
		id: 'contextual-summary.gadgets.activity-feed.description',
		defaultMessage: "Stay up to date with what's happening across the project.",
		description:
			'Description of the Activity Feed which displays a feed of recent issue-centric events/activities on a Jira site, such as updating fields like assignee/status/priority.',
	},
	emptyStateTitle: {
		id: 'contextual-summary.gadgets.activity-feed.empty-state-title',
		defaultMessage: 'No activity yet',
		description: 'Title of the empty state for the Activity Feed.',
	},
	emptyStateDescription: {
		id: 'contextual-summary.gadgets.activity-feed.empty-state-description',
		defaultMessage:
			'Create a few issues and invite some teammates to your project to see your project activity.',
		description: 'Description of the empty state for the Activity Feed.',
	},
	todayLabel: {
		id: 'contextual-summary.gadgets.activity-feed.today-label',
		defaultMessage: 'Today',
		description: 'Label for a heading that groups Activity Feed items that happened today',
	},
	yesterdayLabel: {
		id: 'contextual-summary.gadgets.activity-feed.yesterday-label',
		defaultMessage: 'Yesterday',
		description: 'Label for a heading that groups Activity Feed items that happened yesterday',
	},
});
